import {apiRequest} from '../../ws';
import {TFilter, TList, TResponse} from '@/types';
import {TDetailsParams, TListItem, TListItemV1, TRefundParams} from './types';
import CancelablePromise from 'mn-utils/CancelablePromise';
import {getTransactionDetails, getTransactionList, getTransactionListV1} from './mock';

import {
  ENDPOINT_MERCHANT_TRX_LIST,
  ENDPOINT_MERCHANT_TRX_DETAILS,
  ENDPOINT_MERCHANT_TRX_REFUND
} from '../../../constants/api';

export function apiV2TransactionsList(params: TFilter<TListItem>): Promise<TList<TListItem>> {
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;
  const url = ENDPOINT_MERCHANT_TRX_LIST;

  if (process.env.MOCK) {
    const response = {
      list: getTransactionList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequest(url, params);
}

// Получить детальную информацию по транзакции
export function apiV2GetTransactionDetails(params: TDetailsParams): Promise<TListItem> {
  const url = ENDPOINT_MERCHANT_TRX_DETAILS;

  if (process.env.MOCK) {
    const response = getTransactionDetails();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequest(url, params);
}

export function apiV2TransactionRefund(params: TRefundParams): Promise<TResponse> {
  const url = ENDPOINT_MERCHANT_TRX_REFUND;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequest(url, params);
}
